<template>
    <div class="app__container">

        <app-header></app-header>

        <div class="sections__container">

            <section id="home" class="single__section">
                <video autoplay muted playsinline="true" loop>
                    <source :src="homepage_video.media_URL" type="video/mp4">
                    Your browser does not support HTML video.
                </video>
                <div class="video-overlay"></div>
                <div class="welcome__container">

                    <div class="wrapper">
                        <p class="red">WELCOME TO</p>
                        <h1>GATE21</h1>
                        <p class="regular"><br></p>
                    </div>

                    <div class="about__container">
                        <div class="about__row__wrap centered">
                            <div class="anim_button" @click="scrollToSection('projects')">
                                <p>EXPLORE OUR WORLD</p>
                                <div class="span_bg"></div>
                            </div>
                        </div>
                        <div class="about__row__wrap first-row">
                            <div class="first"></div>
                            <div class="second zero-height"></div>
                            <div class="third"></div>
                        </div>
                        <div class="about__row__wrap second-row">
                            <div class="fourth">
                                <div class="location">
                                    <img src="/images/icons/homeicon.webp" alt="location icon">
                                    <div class="location__details">
                                        <p>Vrbanja 1, Sarajevo, <br>Bosnia and Herzegovina, 71000</p>
                                    </div>
                                </div>
                            </div>
                            <div class="fifth"></div>
                            <div class="sixth">
                                <div class="quote">
                                    <p>
                                        Gate21, a THQ Nordic studio. We are <br> specialized in rigging and pipeline solutions
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="about__row__wrap third-row">
                            <div class="fourth"></div>
                            <div class="fifth"></div>
                            <div class="sixth"></div>
                        </div>
                    </div>

                </div>
            </section>


            <section id="projects" class="section single__section">
                <template v-if="this.projects.length > 0">
                    <projects-slider :projects="this.projects"></projects-slider>
                </template>
            </section>

            <section id="news" class="section single__section">
                <template v-if="this.news.length > 0">
                    <news-section :left_image="news_left_image" :right_image="news_right_image" :news="this.news"></news-section>
                </template>
            </section>

            <section id="team" class="section single__section">
                <team-section :left_image="team_left_image" :right_image="team_right_image"></team-section>
            </section>

            <section id="careers" class="section single__section">
                <careers-section :left_image="careers_left_image" :right_image="careers_right_image" :careers="this.careers"></careers-section>
            </section>

        </div>

        <section id="footer" class="section single__section">
            <app-footer></app-footer>
        </section>


        <div class="bottom__bar" id="bottom_bar">
            <div class="items">
                <template v-if="this.previous_section.id">
                    <a class="previous" @click="scrollToSection(this.previous_section.id)">
                        <p class="red">
                            {{ (this.previous_section.id ? 'TO' : '') }}
                        </p>
                        <p class="number">
                            {{ ( this.previous_section.number ? this.previous_section.number : '') }}
                        </p>
                        <p class="text">
                            <strong>{{ this.previous_section.text_bold }}</strong>&nbsp;&nbsp;{{ this.previous_section.text_regular }}
                        </p>
                    </a>
                </template>
                <template v-else>
                    <a class="previous no-action">
                        <p class="red">
                            {{ (this.previous_section.number ? 'TO' : '') }}
                        </p>
                        <p class="number">
                            {{ ( this.previous_section.number ? this.previous_section.number : '') }}
                        </p>
                        <p class="text">
                            <strong>{{ this.previous_section.text_bold }}</strong>&nbsp;&nbsp;{{ this.previous_section.text_regular }}
                        </p>
                    </a>
                </template>
               
                <div class="current">
                    <p class="red">
                        {{ this.current_section.text_bold }}
                    </p>
                    <p class="title">
                        {{ this.current_section.text_regular }}
                    </p>
                    <p class="number">
                        {{ this.current_section.number }}
                    </p>
                </div>


                <template v-if="this.next_section.id">
                    <a class="next" @click="scrollToSection(this.next_section.id)">
                        <p class="red">
                            {{ (this.next_section.number ? 'TO' : '') }}
                        </p>
                        <p class="number">
                            {{ this.next_section.number }}
                        </p>
                        <p class="text">
                            <strong>{{ this.next_section.text_bold }}</strong>&nbsp;&nbsp;{{ this.next_section.text_regular }}
                        </p>
                    </a>
                </template>
                <template v-else>
                    <a class="next no-action">
                        <p class="red">
                            {{ (this.next_section.number ? 'TO' : '') }}
                        </p>
                        <p class="number">
                            {{ this.next_section.number }}
                        </p>
                        <p class="text">
                            <strong>{{ this.next_section.text_bold }}</strong>&nbsp;&nbsp;{{ this.next_section.text_regular }}
                        </p>
                    </a>
                </template>
                


            </div>
        </div>


    </div>
</template>
<script>
    export default {
        data(){
            return {
                section_in_focus: 'home',
                previous_section: {
                    number: null,
                    text_bold: null,
                    text_regular: null,
                    id: null
                },
                current_section: {
                    number: '00',
                    text_bold: 'OUR',
                    text_regular: 'HOME',
                    id: 'home'
                },
                next_section: {
                    number: '01',
                    text_bold: 'OUR',
                    text_regular: 'PROJECTS',
                    id: 'projects'
                },
                sections: [
                    'home',
                    'projects',
                    'news',
                    'team',
                    'careers',
                    'footer'
                ],
                sections_meta: {
                    'home': {
                        number: '00',
                        text_bold: 'OUR',
                        text_regular: 'HOME',
                        id: 'home'
                    },
                    'projects': {
                        number: '01',
                        text_bold: 'OUR',
                        text_regular: 'PROJECTS',
                        id: 'projects'
                    },
                    'news': {
                        number: '02',
                        text_bold: 'OUR',
                        text_regular: 'NEWS',
                        id: 'news'
                    },
                    'team': {
                        number: '03',
                        text_bold: 'OUR',
                        text_regular: 'TEAM',
                        id: 'team'
                    },
                    'careers': {
                        number: '04',
                        text_bold: '',
                        text_regular: 'CAREER',
                        id: 'careers'
                    },
                    'footer': {
                        number: null,
                        text_bold: null,
                        text_regular: null,
                        id: 'footer'
                    },
                },
                is_scrolling: false,

                COUNTER_THRESHOLD: 2,   // trigger scroll on how many mousewheel roll count (default is 5) (production - 2)
                COUNTER_RESET_DURATION: 50,    // 400 (production - 100)
                SCROLL_SECTION_DELAY: 50,      // 400 (production - 100)
                animating: false,
                counter: 0,
                debounceTimer: null,
                bottomBarDelayTimer: null,
                can_scroll: true,
                is_trackpad: null
            }
        },
        props: [
            'projects', 
            'news', 
            'careers', 
            'homepage_video', 
            'news_left_image', 
            'news_right_image', 
            'team_left_image', 
            'team_right_image', 
            'careers_left_image', 
            'careers_right_image'
        ],
        created(){
            
            var isMobile = {
                Android: function() {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function() {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function() {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function() {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function() {
                    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
                },
                any: function() {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            };

            // window.addEventListener('wheel', this.handleScroll);
            // window.addEventListener('mousewheel', this.handleScroll);
            // mousemove is for tracking cursor movement

            if(!isMobile.any()){
                // window.addEventListener('mousemove', this.trackMovement);

                let supportsPassive = false;
                try {
                    let options = Object.defineProperty({}, 'passive', {
                    get: function() {
                        supportsPassive = true;
                    }
                    });
                    window.addEventListener("testPassive", null, options);
                    window.removeEventListener("testPassive", null, options);
                } catch (e) {}

                let wheelOptions = supportsPassive ? {
                    passive: false
                } : false;

                // if(this.is_trackpad === null){
                    // document.addEventListener("mousewheel", evHandler, false);
                    document.addEventListener("wheel", this.detect_is_trackpad, false);
                    // document.addEventListener("DOMMouseScroll", handler, false);
                // }

                if(!this.is_trackpad){
                    let wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
                    document.addEventListener(wheelEvent, this.handleScroll, wheelOptions);
                }
                
            }
        },

        mounted(){

            setTimeout(() => {
                // set current section from viewport before scrolling
                var current_section = null;
                const sections = document.getElementsByTagName('section');
                for (let index = 0; index < sections.length; index++) {
                    const single_section = sections[index];
                    if(this.isInViewPort(single_section)) current_section = single_section;
                }
                if(current_section){

                    if(this.section_in_focus !== current_section.id){
                        this.updateBottomBar(current_section.id);
                        
                        // hide bottom bar if footer is current section in focus
                        if(current_section.id === 'footer'){
                            this.observeSections(this.getNextSection());
                        }

                        // minimize bottom bar for projects section
                        if(current_section.id === 'projects'){
                            const bottom__bar = document.getElementById('bottom_bar');
                            if(!bottom__bar.classList.contains('minimized')){
                                bottom__bar.classList.add('minimized');
                            }
                        }
                    }
                    this.section_in_focus = current_section.id;
                }
            }, 1000) // 300 old
            
        },

        methods:{
            
            detect_is_trackpad(e){
                var isTouchPad = e.wheelDeltaY ? e.wheelDeltaY === -3 * e.deltaY : e.deltaMode === 0;
                this.is_trackpad = isTouchPad;

                if(isTouchPad){
                    document.body.style = 'overflow-y: auto !important;';
                    document.getElementById('bottom_bar').style = 'display: none !important;'
                }

                document.removeEventListener("wheel", this.detect_is_trackpad);
            },

            resetDelta(){
                this.counter = 0;
            },

            debounce(){
                // let debounceTimer
                // return function() {
                //     const context = this
                //     const args = arguments
                //     clearTimeout(debounceTimer)
                //     debounceTimer
                //         = setTimeout(() => func.apply(context, args), delay)
                // }
                clearTimeout(this.debounceTimer);
                setTimeout(() => {
                    this.resetDelta();
                }, this.COUNTER_RESET_DURATION)
            },

            deboucedReset(){
                this.debounce(this.resetDelta, this.COUNTER_RESET_DURATION)
            },

            trackMovement(event){
                // if(this.getParentElement(event.target,'team_scrolldiv') || this.getParentElement(event.target, 'careers_scrolldiv')){
                //     this.can_scroll = false;
                // } else {
                //     this.can_scroll = true;
                // }
            },

            getParentElement(target_element, parent_element){
                parent_element = document.getElementById(parent_element);
                return parent_element.contains(target_element)
            },

            handleScroll(event) {
                if(!this.can_scroll) return;

                if(this.is_trackpad) return;

                //event.wheelDelta can be positive or negative based on the direction of scroll
                this.counter += 1 * (Math.sign(event.wheelDelta));
                
                ////////////////////  disable programmatic scroll - for now (only set bottom bar anchor points)
                const current_section = this.sections.filter((section) => this.isInViewPort(document.getElementById(section)));
                this.updateBottomBar(current_section[0]);
                this.section_in_focus = current_section[0];
                this.observeSections(this.getNextSection());
                return;
                /////////////////////////////////////////////////////////////////////////////////////////
               
                
                // scroll down if value of counter is negative and absolute value is greater than threshold
                if (!this.animating && (Math.abs(this.counter) >= this.COUNTER_THRESHOLD) && this.counter < 0) {
                    let targetSection = this.getNextSection();

                    if (targetSection) {
                        this.scrollToSection(targetSection);
                    }
                }

                // scroll up if value of counter is positive and absolute value is greater than threshold
                else if (!this.animating && (Math.abs(this.counter) >= this.COUNTER_THRESHOLD) && this.counter > 0) {
                    let targetSection = this.getPreviousSection();

                    if (targetSection) {
                        this.scrollToSection(targetSection);
                    }
                }
                // prevent default scrolling behaviour of mouse wheel
                event.preventDefault()

                //Reset counter to 0 , 400 miliseconds after stopping the mousewheel
                this.deboucedReset();
            },

            observeSections(next_section){
                const bottom__bar = document.getElementById('bottom_bar');

                // console.clear();
                // console.log('previous section: ' + this.getPreviousSection());
                // console.log('section in focus: ' + this.section_in_focus);
                // console.log('next section: ' + this.getNextSection());
                // console.log('targeted section: ' + next_section);

                // hide bottom bar if next / prev section is projects
                if(
                    // top to bottom
                    this.getNextSection() === 'projects' || 
                    // bottom to top
                    (this.section_in_focus === 'news' && this.getPreviousSection() === 'projects' && this.getNextSection() === 'team' && next_section === 'projects') ||
                    (this.section_in_focus === 'careers' && this.getPreviousSection() === 'team' && this.getNextSection() === 'footer' && next_section === 'footer')
                ){
                    setTimeout(() => {
                        if(!bottom__bar.classList.contains('minimized')){
                            bottom__bar.classList.add('minimized');
                        }
                    }, this.COUNTER_RESET_DURATION / 2)
                    
                } else {
                    setTimeout(() => {
                        if(bottom__bar.classList.contains('minimized')) bottom__bar.classList.remove('minimized');
                    }, this.COUNTER_RESET_DURATION / 2)
                }
            },

            getNextSection(){
                var next_section = null;
                for (var index = 0; index < this.sections.length; index++) {
                    const section = this.sections[index];
                    if(this.section_in_focus == section){
                        if(this.sections[index + 1]){
                            next_section = this.sections[index + 1];
                        }
                    }
                }
                
                return next_section;
            },

            getPreviousSection(){
                var prev_section = null;
                for (var index = this.sections.length; index >= 0; index--) {
                    const section = this.sections[index];
                    if(this.section_in_focus == section){
                        if(this.sections[index - 1]){
                            prev_section = this.sections[index - 1];
                            break;
                        }
                    }
                }

                return prev_section;
            },

            scrollToSection(target){
                // observe sections to adapt bottom bar
                this.observeSections(target);

                const elem = document.getElementById(target);
                this.animating = true;

                setTimeout(() => {
                    elem.scrollIntoView({behavior: "smooth", block: "end"});
                    this.section_in_focus = target;
                    this.animating = false;

                    // set bottom bar info
                    this.updateBottomBar(target);
                }, this.SCROLL_SECTION_DELAY);
            },

            updateBottomBar(target){

                for (var index = 0; index < this.sections.length; index++) {
                    const section = this.sections[index];
                    if(section === target){

                        const previous_section_name = this.sections[index - 1];
                        const next_section_name = this.sections[index + 1];

                        // set previous if exists
                        if(previous_section_name) { this.previous_section = this.sections_meta[previous_section_name]; 
                        } else { 
                            this.previous_section = {
                                number: null,
                                text_bold: null,
                                text_regular: null,
                                id: null
                            } 
                        }
                        
                        // set current section
                        this.current_section = this.sections_meta[target];

                        // set next section if exists
                        if(next_section_name) { 
                            this.next_section = this.sections_meta[next_section_name];
                        } else {
                            this.next_section = {
                                number: null,
                                text_bold: null,
                                text_regular: null,
                                id: null
                            } 
                        }

                    }
                }
            },

            isInViewPort(el){
                // const rect = el.getBoundingClientRect();

                // console.log(
                //     el.id, 
                //     ((rect.top + 3) >= 0), 
                //     ((rect.top + 3) >= 0), 
                //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight),
                //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                // );

                // return (
                //     // rect.top >= 0 &&
                //     (rect.top + 3) >= 0 && // add 3 pixels for border bottom at each section
                //     (rect.top + 3) >= 0 &&
                //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                // );

                const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
                    const { top, left, bottom, right } = el.getBoundingClientRect();
                    const { innerHeight, innerWidth } = window;
                    return partiallyVisible
                        ? ((top > 0 && top < innerHeight) ||
                            (bottom > 0 && bottom < innerHeight)) &&
                            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
                        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
                };

                return elementIsVisibleInViewport(el, true); // false - (not fully visible), true - (partially visible)
            },

            // checkCurrentSection(){
            //     const sections = document.getElementsByTagName('section');
            //     for (let index = 0; index < sections.length; index++) {
            //         const single_section = sections[index];
                    
            //         // console.log(this.isInViewPort(single_section), single_section.id);

            //         if(this.isInViewPort(single_section)){
            //             this.section_in_focus = single_section.id;
            //         }
            //         // console.log(this.isInViewPort(single_section), single_section.id)
            //     }
            // },
        }
    }
</script>
<style lang="scss" scoped>
    .app__container{
        width: 100%;
        height: 100vh;
        position: relative;
        z-index: 1;

        .sections__container{
            display: flex;
            flex-direction: column;
            z-index: 1;

            width: 100%;
            max-width: 1920px;
            overflow: hidden;
            margin-left: auto;
            margin-right: auto;

            .single__section{
                width: 100%;
                // padding-top: 92px;
                // height: calc(100vh - (96px + 64px));
                // height: calc(100vh - 92px);
                height: 100vh;
                // background: grey;
                // background: black;
                border-bottom: 3px solid #ED1163;

                overflow: hidden;
                position: relative;
            }

            #home{
                // margin-top: 92px;
                border-bottom: 0;

                // background: red;

                video{
                    position: absolute; 
                    right: 0; 
                    // bottom: 0;
                    // top: 92px;
                    top: 0;
                    min-width: 100%; 
                    min-height: 100%;
                    width: auto; 
                    height: auto; 
                    z-index: 0;
                    background-size: cover;
                    overflow: hidden;
                }

                .video-overlay{
                    position: absolute;
                    // top: 0;
                    top: 92px;
                    left: 0;
                    background: rgba($color: #5C2C90, $alpha: 0.4);
                    z-index: 1;
                    display: block;
                    width: 100%;
                    height: 100%;
                }

                .welcome__container{
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    width: 100%;
                    height: 100%;
                    z-index: 2;

                    .wrapper{
                        position: absolute;
                        // top: 50%; right: 50%;
                        top: 48%; right: 50%;
                        transform: translate(50%,-50%);

                        p.red{
                            font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-weight: 700;
                            font-size: 26px;
                            line-height: 31px;

                            text-align: center;
                            letter-spacing: 0.385em;
                            text-transform: uppercase;

                            color: #ED1163;
                            margin-bottom: 0;

                            margin-right: -12px;
                        }

                        h1{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 120px;
                            line-height: 54px;
                            /* or 45% */

                            text-align: center;
                            text-transform: uppercase;

                            color: #FFFFFF;
                            margin: 0;
                            margin-top: 38px;
                            margin-bottom: 42px;

                            margin-right: -12px;
                        }

                        p.regular{
                            font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-weight: 300;
                            font-size: 22px;
                            line-height: 30px;
                            /* or 136% */

                            text-align: center;
                            color: #FFFFFF;
                        }
                    }
                }

                .about__container{
                    display: flex;
                    flex-direction: column;
                    margin-top: auto;
                    margin-bottom: 0;

                    .about__row__wrap{
                        display: flex;
                        flex-direction: row;

                        &.centered{
                            justify-content: center;
                        }

                        .anim_button{
                            display: block;
                            background: rgba(0, 0, 0, 0.6);
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            width: 409px;
                            height: 50px;
                            margin-bottom: -9px;
                            cursor: pointer;
                            user-select: none;
                            position: relative;
                            overflow-y: hidden;
                            z-index: 4;
                            text-decoration: none;

                            p{
                                font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 700;
                                font-size: 20px;
                                line-height: 50px;
                                text-align: center;
                                letter-spacing: 0.2em;
                                text-transform: uppercase;
                                margin: 0 auto;

                                color: #FFFFFF;
                                position: relative;
                                z-index: 4;
                            }

                            div.span_bg{
                                background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                                height: 100%;
                                width: 100%;
                                transition: all .3s ease-in-out;
                                margin-top: auto;
                                margin-bottom: 0;
                                opacity: 0;

                                position: absolute;
                                bottom: -50px;
                                z-index: 3;
                            }

                            &:hover{
                                div.span_bg{
                                    height: calc(100%);
                                    bottom: 0;
                                    opacity: 1;
                                }
                            }
                        }

                        .first{
                            border-top: 1px solid #ED1163;
                            border-right: 1px solid #ED1163;
                            width: 100%;
                            // max-width: 749px;
                            height: 17px;

                            background: rgba(28, 28, 28, 0.4);
                        }

                        .second{
                            border-top: 1px solid #ED1163;
                            width: 100%;
                            max-width: 426px;
                            height: 1px;
                            // margin-top: 16px;
                            margin-top: 17px;

                            &.zero-height{
                                height: 0;
                            }
                        }

                        .third{
                            border-top: 1px solid #ED1163;
                            border-left: 1px solid #ED1163;
                            width: 100%;
                            // max-width: 749px;
                            height: 17px;
                            background: rgba(28, 28, 28, 0.4);
                        }

                        .fourth, .fifth, .sixth{
                            width: 100%;
                            height: 74px;
                            background: rgba(28, 28, 28, 0.4);
                        }

                        .fourth{
                            .location{
                                display: flex;
                                flex-direction: row;
                                margin-left: 51px;

                                img{
                                    display: block;
                                    width: 20px;
                                    height: 25px;
                                    margin-top: auto;
                                    margin-bottom: auto;
                                }

                                .location__details{
                                    display: flex;
                                    flex-direction: column;
                                    margin-left: 12px;

                                    p{
                                        font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                        font-style: normal;
                                        font-weight: 400;
                                        font-size: 16px;
                                        line-height: 19px;
                                        align-items: center;
                                        text-transform: uppercase;

                                        color: #FFFFFF;
                                    }
                                }
                            }
                        }

                        .sixth{
                            .quote{
                                display: flex;
                                flex-direction: column;
                                margin-left: 12px;

                                p{
                                    font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                                    font-style: normal;
                                    font-weight: 300;
                                    font-size: 16px;
                                    line-height: 19px;
                                    // align-items: center;
                                    text-transform: uppercase;

                                    color: #FFFFFF;
                                    // text-align: left;
                                    text-align: right;

                                    margin-left: auto;
                                    // margin-right: 21px;
                                    margin-right: 51px;
                                }
                            }
                        }
                    }
                }
            }

            #footer{
                height: 396px;
                border-bottom: none;
            }
        }

        .bottom__bar{
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 64px;

            // background: #1A1A1A;
            background: linear-gradient(360deg, #1A1A1A -0.25%, #222222 100%);
            z-index: 5;

            transition: all .3s ease-in-out;

            &.minimized{
                bottom: -64px;
            }

            .items{
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                max-width: 1920px;
                margin-left: auto;
                margin-right: auto;

                .previous{
                    width: 155px;
                    margin-left: 8px;

                    display: flex;
                    flex-direction: row;
                    margin-right: 8px;
                    cursor: pointer;

                    &.no-action{
                        cursor: default;
                    }

                    &:hover{

                        p.text{
                            color: #ED1163;
                        }

                        p.number{
                            color: #ED1163;
                        }
                    }

                    p.red{
                        font-family: "DIN Next LT Pro UltraLight", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ED1163;
                        margin-right: 15px;
                        margin-top: 14px;
                    }

                    p.number{
                        font-family: "DIN Next LT Pro UltraLight", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ffffff;
                        margin-top: 14px;
                        margin-right: 5px;
                        
                        transition: .5s ease-in-out;
                    }

                    p.text{
                        font-family: "DIN Next LT Pro UltraLight", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ffffff;
                        margin-top: 14px;

                        transition: .75s ease-in-out;
                    }
                }

                .current{
                    width: 240px;

                    display: flex;
                    flex-direction: row;

                    p.red{
                        font-family: "DIN Next LT Pro Light", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 25px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        margin-top: 23px;

                        color: #ED1163;
                    }

                    p.title{
                        font-family: "DIN Next LT Pro Light", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 25px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ffffff;
                        margin-top: 23px;
                        margin-left: 8px;
                    }

                    p.number{
                        font-family: "DIN Next LT Pro Light", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 25px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ED1163;
                        margin-top: 23px;
                        margin-left: 42px;
                    }
                }

                .next{
                    display: flex;
                    flex-direction: row;
                    margin-right: 8px;
                    width: 155px;
                    cursor: pointer;

                    &.no-action{
                        cursor: default;
                    }

                    &:hover{

                        p.text{
                            color: #ED1163;
                        }

                        p.number{
                            color: #ED1163;
                        }
                    }

                    p.red{
                        font-family: "DIN Next LT Pro UltraLight", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ED1163;
                        margin-right: 15px;
                        margin-top: 14px;
                    }

                    p.number{
                        font-family: "DIN Next LT Pro UltraLight", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ffffff;
                        margin-top: 14px;
                        margin-right: 5px;

                        transition: .5s ease-in-out;
                    }

                    p.text{
                        font-family: "DIN Next LT Pro UltraLight", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        /* or 100% */

                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ffffff;
                        margin-top: 14px;

                        transition: .75s ease-in-out;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1750px) {
    
        .app__container{

            .bottom__bar{
                
                .items{
                    margin-right: 24px;
                    margin-left: 24px;
                }
            }

        }        

    }

    @media screen and (max-width: 836px) {
    
        .app__container{

            .sections__container{

                #home{

                    video, .video-overlay{
                        top: 60px;
                    }
                    
                    video{
                        left: -145%;
                    }
                    
                    .welcome__container{

                        .wrapper{
                            p.red{
                                font-size: 20px;
                                line-height: 24px;
                            }

                            h1{
                                font-size: 76px;
                                line-height: 54px;
                                margin-top: 12px;
                                margin-bottom: 0;
                            }

                            p.regular{
                                font-size: 14px;
                                line-height: 19px;
                                margin-top: 8px;
                            }
                        }


                        .about__container{
                            margin-bottom: 0;

                            .about__row__wrap.centered{
                                .anim_button{
                                    margin-bottom: 55px;
                                    width: 245px;
                                    height: 35px;

                                    p{
                                        font-size: 12px;
                                        line-height: 37px; 
                                    }
                                }
                            }

                            .about__row__wrap.first-row{
                                display: none;
                            }

                            .about__row__wrap.second-row{
                                .fourth{
                                    height: initial;

                                    .location{
                                        flex-direction: column;
                                        margin-left: 0;

                                        img{
                                            margin-left: auto;
                                            margin-right: auto;
                                            margin-top: 12px;
                                        }

                                        .location__details{

                                            p{
                                                font-size: 12px;
                                                line-height: 14px;
                                                text-align: center;
                                            }
                                        }
                                    }
                                }

                                .fifth, .sixth{
                                    display: none;
                                }
                            }

                            .about__row__wrap.third-row{
                                display: none;
                            }
                        }

                    }

                }

                #projects{
                    height: 100%;
                    overflow: initial;
                }

                #news{
                    height: 100%;
                    overflow: initial;
                }

                #team{
                    height: 100%;
                    overflow: initial;
                }

                #careers{
                    height: 100%;
                    overflow: initial;
                }

            }

            .bottom__bar{
                display: none;

                .items{
                    .previous, .next{
                        display: none;
                    }

                    .current{

                    }
                }
                
            }
        }

    }

    @media screen and (max-width: 836px) and (orientation: landscape) {
        .app__container {
            .sections__container {
                #home {
                    height: 100%;

                    .welcome__container{

                        .wrapper{
                            top: 38%;
                        }

                        .about__container{
                            margin-top: calc(60vh);

                            .about__row__wrap.centered{
                                .anim_button{
                                    margin-bottom: 20px;
                                }
                            }
                        }
                    }
                }
                
            }
        }
    }

</style>